import useNotification from "./useNotification";

export { useNotification };

const hooks = { useNotification };

export default hooks;
